import { Button, DialogActions, TextField, Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { useState } from 'react';
import api from '../services/api';
import Dialog from '@mui/material/Dialog';
import { styled } from '@mui/material/styles';
import { useSelector } from 'react-redux';
import MessageSuccess from '../messages/messageSuccess';
import MessageError from '../messages/messageError';
import LoadingShort from '../load/loadingShort';
import { useNavigate } from 'react-router-dom';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
}));

const Delete = (props) => {
    const reduxUserId = useSelector(state => state.account.user?._id);
    const userId = props.userId ?? reduxUserId;
    const [open, setOpen] = useState(false);
    const [messageSuccess, setMessageSuccess] = useState('')
    const [messageError, setMessageError] = useState('')
    const [observacao, setObservacao] = useState('');
    const [obsError, setObsError] = useState(false);
    const navigate = useNavigate()

    const handleClose = () => {
        props.setOpen(false);
    };

    const handleDelete = () => {
        setMessageSuccess('')
        setMessageError('')
        if (!userId) {
            setMessageError('Usuário não autenticado. Faça login novamente.');
            return;
        }
        if (!observacao || observacao.trim().length === 0) {
            setObsError(true);
            setMessageError('A observação é obrigatória para remover.');
            return;
        } else {
            setObsError(false);
        }
        setOpen(true)
        const dadosEnvio = { id: props.id, userId, observacao };
        api.delete(`${props.url}/`, { data: dadosEnvio })
            .then(response => {
                // console.log(response) 
                setOpen(false)
                setMessageSuccess(`${props.tipo} removido(a) com sucesso.`)

                setTimeout(() => {
                    navigate(-1)
                }, 5000);

            }).catch(err => {
                setOpen(false)
                setMessageError('Erro ao eliminar')
            })
    }

    return (
        <>
            <BootstrapDialog
                scroll='body'
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={props.open}
            >
                <div style={{ padding: 20 }}>
                    <div style={{ marginBottom: 16 }}>
                        <TextField
                            id="observacao"
                            label="Observação para remoção"
                            multiline
                            minRows={3}
                            maxRows={6}
                            fullWidth
                            variant="outlined"
                            value={observacao}
                            onChange={e => { setObservacao(e.target.value); setObsError(false); }}
                            placeholder="Explique brevemente o motivo da exclusão dos dados..."
                            required
                            error={obsError}
                            helperText={obsError ? 'Campo obrigatório' : ''}
                        />
                    </div>

                    <Typography>
                        {props.msg} ?
                    </Typography>

                    {messageSuccess && <MessageSuccess message={messageSuccess} />}
                    {messageError && <MessageError message={messageError} />}

                    {!messageSuccess &&
                        <DialogActions>
                            <Button title='Cancelar' onClick={() => props.setOpen(false)} size="small" >Cancelar</Button>
                            <Button title='Remover' onClick={handleDelete} size="small" color="error" variant="contained" disabled={!observacao || observacao.trim().length === 0}>
                                {open ? <LoadingShort /> : 'Remover'}
                            </Button>
                        </DialogActions>
                    }
                </div>
            </BootstrapDialog>
        </>
    );
}

export default Delete;
